import { BaseComponent } from '../core/BaseComponent';

export interface TabsOptions {
  activeTab: number;
  onSwitch?: (index: number) => void;
}

export interface TabsState {
  activeTab: number;
}

export class Tabs extends BaseComponent<TabsOptions, TabsState> {
  private navItems: HTMLElement[] = [];
  private panels: HTMLElement[] = [];

  protected getDefaultOptions(): TabsOptions {
    return {
      activeTab: 0
    };
  }

  protected init(): void {
    super.init();
    this.navItems = Array.from(this.element.querySelectorAll('.tab, .tab-nav .btn'));
    this.panels = Array.from(this.element.querySelectorAll('.tab-panel, .tab-pane'));
    
    this.element.setAttribute('role', 'tablist');
    
    this.navItems.forEach((item, index) => {
      item.setAttribute('role', 'tab');
      item.setAttribute('aria-selected', 'false');
      item.setAttribute('tabindex', '-1');
      
      item.addEventListener('click', (e) => {
        e.preventDefault();
        this.show(index);
      });

      item.addEventListener('keydown', (e) => this.handleKeydown(e, index));
    });

    this.panels.forEach(panel => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('tabindex', '0');
    });

    const activeIndex = this.navItems.findIndex(i => i.classList.contains('active'));
    this.show(activeIndex !== -1 ? activeIndex : this.options.activeTab);
  }

  public show(index: number): void {
    if (index < 0 || index >= this.navItems.length) return;

    this.navItems.forEach((item, i) => {
      const isActive = i === index;
      item.classList.toggle('active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
      // if (isActive && document.activeElement && this.navItems.includes(document.activeElement as HTMLElement)) item.focus();
    });

    this.panels.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle('active', isActive);
      panel.classList.toggle('d-none', !isActive);
    });

    this.state.activeTab = index;
    if (this.options.onSwitch) this.options.onSwitch(index);
    this.emit('switch', { index });
  }

  private handleKeydown(e: KeyboardEvent, index: number): void {
    let nextIndex: number | undefined;
    if (e.key === 'ArrowRight') nextIndex = (index + 1) % this.navItems.length;
    else if (e.key === 'ArrowLeft') nextIndex = (index - 1 + this.navItems.length) % this.navItems.length;
    else if (e.key === 'Home') nextIndex = 0;
    else if (e.key === 'End') nextIndex = this.navItems.length - 1;

    if (nextIndex !== undefined) {
      e.preventDefault();
      this.show(nextIndex);
      this.navItems[nextIndex].focus();
    }
  }
}
